import KitAB from "../AB/KitAB";
import KitAPI from "../KitAPI";
import KitCfg from "../KitCfg";
import {KitSp} from "../KitSp";
import {IapConstants} from "./IapConst";
import {SmIDQuery} from "./SmIDQuery";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class DeviceData {
    private static map: JsonData = new JsonData();
    private static sumengAppKey = "";
    private static _sm_id = "";
    static Init() {
        KitAPI.InitShuzilmSDK(this.sumengAppKey);

        //获取同盾ID和数盟ID

        SmIDQuery.Query();

        this.map.put(IapConstants.PACKAGE_NAME, KitAPI.packageName);
        // 基本属性
        this.map.put(IapConstants.VERSION_CODE, KitAPI.versionCode);
        this.map.put(IapConstants.BRAND, KitAPI.osBrand);
        this.map.put(IapConstants.MODEL, KitAPI.osModel);
        this.map.put(IapConstants.OS, KitAPI.osType);
        this.map.put(IapConstants.U_ID, KitAPI.UUID);
        this.map.put(IapConstants.TD_BLACK_BOX, "");
        this.map.put(IapConstants.UUID, KitAPI.ADID);
        this.map.put(IapConstants.SM_ID, this.GetSmID());
    }


    private static getDeviceInfoMap(): JsonData {
        // 基本属性
        var ignore = KitAB.getBooleanConfig("iap_ignore_location"); //特殊需求，忽略国家和语言信息，防止被拉入黑名单
        this.map.put(IapConstants.OS_COUNTRY, ignore ? "US" : KitAPI.country);
        this.map.put(IapConstants.OS_LANGUAGE, ignore ? "en" : KitAPI.language);
        // 环境属性
        this.map.put(IapConstants.IS_SIMULATOR, KitAPI.isSimulator);
        this.map.put(IapConstants.IS_DEV_MODEL, KitAPI.IsOpenDevelopmentSetting());
        this.map.put(IapConstants.IS_DEBUG, KitAPI.IsOpenedUSBDebug());
        // this.map.put(IapConstants.IS_XPOSED, KitAPI.isXpose);
        this.map.put(IapConstants.IS_ABNORMAL_ENV, KitAPI.isRoot);
        this.map.put(IapConstants.SIM_MCC, KitAPI.MCC);
        // 网络属性
        this.map.put(IapConstants.IS_VPN, KitAPI.isVpnConnected());
        this.map.put(IapConstants.IS_PROXY, KitAPI.isWifiProxy());
        return this.map;
    }

    static putSmID(id: string) {
        if (!id) return;
        this._sm_id = id;
        this.map.put(IapConstants.SM_ID, id);
        KitSp.SetString(IapConstants.SM_ID, id);
        KitSp.Apply();
    }

    static GetSmID(): string {
        if (this._sm_id) return this._sm_id;
        this._sm_id = KitSp.GetString(IapConstants.SM_ID);
        if (this._sm_id) {
            this.map.put(IapConstants.SM_ID, this._sm_id);
            return this._sm_id;
        }

        return this._sm_id;
    }

    static buildBaseParams(scene: number, userGroup: JsonData): JsonData {
        const deviceInfo = this.getDeviceInfoMap();
        const json = new JsonData();

        json.put(IapConstants.PRODUCT_ID, KitCfg.productId);
        json.put(IapConstants.SCENE, scene);
        json.put(IapConstants.PACKAGE_NAME, KitAPI.packageName);
        json.put(IapConstants.OS, KitAPI.osType);
        json.put(IapConstants.VERSION_CODE, KitAPI.versionCode);
        json.put(IapConstants.REQ_UNIQUE, this.newGuid());
        json.put(IapConstants.H5_HOST_NAME, KitAPI.WebHotName);

        const ext = new JsonData();
        const basicGroup = new JsonData();
        basicGroup.put(IapConstants.BRAND, KitAPI.osBrand);
        basicGroup.put(IapConstants.MODEL, KitAPI.osModel);

        const ignore = KitAB.getBooleanConfig("iap_ignore_location"); //特殊需求，忽略国家和语言信息，防止被拉入黑名单
        basicGroup.put(IapConstants.OS_COUNTRY, ignore ? "US" : KitAPI.country);
        basicGroup.put(IapConstants.OS_LANGUAGE, ignore ? "en" : KitAPI.language);
        basicGroup.put(IapConstants.UUID, KitAPI.ADID);
        basicGroup.put(IapConstants.U_ID, KitAPI.UUID);
        basicGroup.put(IapConstants.SM_ID, this.GetSmID());
        // if (KitAPI.IS_IOS) basicGroup.put(IapConstants.LOC_COUNTRY, ignore ? "US" : KitAPI.LocalCountry);

        const envGroup = new JsonData();
        envGroup.put(IapConstants.IS_SIMULATOR, KitAPI.isSimulator);
        envGroup.put(IapConstants.IS_DEBUG, KitAPI.IsOpenedUSBDebug());
        envGroup.put(IapConstants.IS_ABNORMAL_ENV, KitAPI.isRoot);
        envGroup.put(IapConstants.SIM_MCC, KitAPI.MCC);
        if (KitAPI.IS_IOS) envGroup.put(IapConstants.IS_VIR_LOC, KitAPI.IsVirLoc());

        const netGroup = new JsonData();
        netGroup.put(IapConstants.IS_VPN, KitAPI.isVpnConnected());
        netGroup.put(IapConstants.IS_PROXY, KitAPI.isWifiProxy());
        // if (KitAPI.IS_IOS) netGroup.put(IapConstants.SSID, KitAPI.SSID());
        // if (KitAPI.IS_IOS) netGroup.put(IapConstants.MAC, KitAPI.MAC());

        ///没接入同盾，参数值传空
        const thirdGroup = new JsonData();
        thirdGroup.put(IapConstants.TD_BLACK_BOX, deviceInfo.OptString(IapConstants.TD_BLACK_BOX));

        ext.put(IapConstants.BASIC_GROUP, basicGroup);
        ext.put(IapConstants.ENV_GROUP, envGroup);
        ext.put(IapConstants.NET_GROUP, netGroup);
        ext.put(IapConstants.USER_GROUP, userGroup);
        json.put(IapConstants.EXT_FIELDS, ext);
        json.put(IapConstants.THIRD_PARAM_FIELDS, thirdGroup);
        return json;
    }

    private static newGuid(): string {
        // 生成一个新的 UUID
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: string) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
